import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'codes',
            name: 'code',
            class: 'Modules\\Site\\Entities\\Code'
        }
    }
}